import { coverFeature, deepDiveList } from '@/mocks/deepDive';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function DeepDive() {
  return (
    <section id="deepdive" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          kicker="Cover Story"
          title="封面深挖 · 把线索摆上同一张桌子"
          description="每一期只回答一个问题，用可核验的报价、时间与人物关系，替代情绪化的猜测。"
          linkHref="#channels"
          linkLabel="浏览全部栏目"
        />

        <div className="mt-10 grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <article className="group lg:col-span-7">
            <div className="w-full overflow-hidden rounded-lg border border-background-300 bg-background-50">
              <div className="h-[240px] w-full overflow-hidden md:h-[360px]">
                <img
                  src={coverFeature.image}
                  alt="本期封面深挖：一条热搜的成本清单"
                  title="17爆料网 封面深挖 资本运作"
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-7">
                <span className="inline-flex items-center gap-2 rounded bg-primary-500 px-3 py-1 text-[11px] font-medium tracking-[0.16em] text-background-50">
                  <i className="ri-fire-line" />
                  {coverFeature.kicker}
                </span>
                <h3 className="mt-4 cursor-pointer font-heading text-xl font-bold leading-snug text-foreground-950 transition-colors hover:text-primary-600 md:text-[28px]">
                  {coverFeature.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{coverFeature.summary}</p>
                <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-background-200 pt-4 text-xs text-foreground-500">
                  {coverFeature.meta.map((meta) => (
                    <span key={meta} className="flex items-center gap-1.5 whitespace-nowrap">
                      <i className="ri-time-line text-sm text-accent-600" />
                      {meta}
                    </span>
                  ))}
                  <a
                    href="#deepdive"
                    className="ml-auto flex items-center gap-1.5 whitespace-nowrap font-medium text-primary-600 transition-colors hover:text-primary-700"
                  >
                    阅读全文
                    <i className="ri-arrow-right-line text-base" />
                  </a>
                </div>
              </div>
            </div>
          </article>

          <div className="lg:col-span-5">
            <p className="flex items-center gap-2 text-[11px] font-medium uppercase tracking-[0.22em] text-foreground-500">
              <i className="ri-stack-line text-sm text-primary-500" />
              同期刊载
            </p>
            <div className="mt-5 flex flex-col divide-y divide-background-200 border-y border-background-200">
              {deepDiveList.map((item, index) => (
                <article key={item.id} className="group flex cursor-pointer gap-4 py-5">
                  <span className="font-heading text-2xl font-bold text-background-400 transition-colors group-hover:text-primary-500 md:text-3xl">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <div className="h-16 w-16 shrink-0 overflow-hidden rounded-md border border-background-300">
                    <img
                      src={item.image}
                      alt={item.title}
                      title={`17爆料网 ${item.tag} 深挖`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <span className="rounded bg-accent-100 px-2 py-0.5 text-[10px] font-medium text-accent-900">
                      {item.tag}
                    </span>
                    <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                    <span className="mt-2 flex items-center gap-1.5 text-[11px] text-foreground-500">
                      <i className="ri-time-line" />
                      {item.read}
                    </span>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}